/**
 * Metadados do protocolo de triagem adotado numa aula — nunca uma regra.
 *
 * Fase 5B, deliberadamente sem classificação automática: o app não decide cor,
 * categoria nem limiar clínico. Só registra QUAL protocolo o professor está
 * usando como referência (nome, versão, população, fonte), para a aula não
 * misturar sistemas em silêncio nem apresentar um rótulo genérico como se
 * fosse uma regra validada. Ligar uma classificação automática de verdade
 * exigiria confirmar a edição usada e revisão clínica/pedagógica responsável
 * — fora do escopo desta fase.
 */
export interface ProtocoloTriagem {
  nome: string
  versao: string
  populacao: string
  fonte: string
}

/** Estado inicial de um cenário recém-criado: nenhum protocolo declarado ainda. */
export const PROTOCOLO_NAO_DEFINIDO: ProtocoloTriagem = {
  nome: '',
  versao: '',
  populacao: '',
  fonte: '',
}

export const protocoloDefinido = (protocolo: ProtocoloTriagem): boolean =>
  protocolo.nome.trim().length > 0 && protocolo.fonte.trim().length > 0
